// Smooth reload overlay — replaces bare window.location.reload() / href
// navigation with a branded, animated transition so the user sees a
// professional indicator instead of a jarring white-screen freeze.
//
// Usage:
//   showReloadOverlay()               — reload in place
//   showReloadOverlay({ url })        — navigate to a specific URL
//   showReloadOverlay({ cacheBust })  — append _t=timestamp before navigating

const REFRESH_SVG = `
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25"
     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
  <polyline points="3 3 3 8 8 8"/>
</svg>`;

function caption(lang) {
	return lang === "ar" ? "جارٍ إعادة التحميل…" : "Refreshing…";
}

let injected = false;

function buildOverlay() {
	const lang = document.documentElement.getAttribute("lang") || "en";
	const node = document.createElement("div");
	node.className = "e16-reload-overlay";
	node.setAttribute("role", "status");
	node.setAttribute("aria-live", "polite");
	node.innerHTML = `
		<div class="e16-reload-overlay__icon">${REFRESH_SVG}</div>
		<div class="e16-reload-overlay__caption">${caption(lang)}</div>
		<div class="e16-reload-overlay__bar"></div>
	`;
	return node;
}

function doNavigate(url) {
	try {
		if (url) {
			window.location.href = url;
		} else {
			window.location.reload();
		}
	} catch (e) {
		window.location.reload();
	}
}

export function showReloadOverlay({ url = null, cacheBust = false } = {}) {
	// Guard: only one overlay at a time
	if (injected || document.querySelector(".e16-reload-overlay")) {
		doNavigate(url);
		return;
	}
	injected = true;

	let targetUrl = url;
	if (cacheBust && !targetUrl) {
		try {
			const u = new URL(window.location.href);
			u.searchParams.set("_t", String(new Date().getTime()));
			targetUrl = u.toString();
		} catch (e) {}
	}

	try {
		const node = buildOverlay();
		(document.body || document.documentElement).appendChild(node);
		// Force reflow so the CSS transition fires from opacity:0 → 1
		node.getBoundingClientRect();
		node.classList.add("is-visible");

		// Navigate after the overlay has rendered
		setTimeout(() => doNavigate(targetUrl), 200);
	} catch (e) {
		// Overlay build failed — navigate immediately
		injected = false;
		doNavigate(targetUrl);
	}
}
